import { Component, input, output, EventEmitter } from '@angular/core';
import { EvExpandedIconComponent } from "ev-expanded-icon";
import { NgClass } from '@angular/common';

@Component({
    selector: 'sub-group',
    templateUrl: './sub-group.component.html',
    styleUrls: ["../../styles/component-accordion.scss", './sub-group.component.scss'],
    imports: [NgClass, EvExpandedIconComponent]
})
export class SubGroupComponent {
  headerText = input<string>("");
  infoText = input<string>("");
  noPadding = input<boolean>(false);
  showExpandedBorder = input<boolean>(false);
  onExpanded = output<boolean>();

  expanded: boolean = false;

  onExpandClicked(): void {
    this.expanded = !this.expanded;
    this.onExpanded.emit(this.expanded);
  }
}
